import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Dashboard from "@/pages/Dashboard";
import Cadastros from "@/pages/Cadastros";
import ServiceOrders from "@/pages/ServiceOrders";
import Inventory from "@/pages/Inventory";
import Financial from "@/pages/Financial";
import ServicesCatalog from "@/pages/ServicesCatalog";
import FiscalNotes from "@/pages/FiscalNotes";
import Company from "@/pages/Company";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import { Toaster } from "@/components/ui/sonner";
import { CompanyProvider } from "@/lib/CompanyContext";
import { AuthProvider } from "@/lib/AuthContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CompanyProvider>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/auth/callback" element={<AuthCallback />} />

              {/* Protected routes */}
              <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/ordens" element={<ServiceOrders />} />
                <Route path="/cadastros" element={<Cadastros />} />
                <Route path="/clientes" element={<Navigate to="/cadastros?tab=clientes" replace />} />
                <Route path="/veiculos" element={<Navigate to="/cadastros?tab=veiculos" replace />} />
                <Route path="/estoque" element={<Inventory />} />
                <Route path="/servicos" element={<ServicesCatalog />} />
                <Route path="/financeiro" element={<Financial />} />
                <Route path="/notas" element={<FiscalNotes />} />
                <Route path="/empresa" element={<Company />} />
              </Route>
            </Routes>
          </CompanyProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
